import { render, staticRenderFns } from "./ActualizarWS.vue?vue&type=template&id=2ae6bce0&"
import script from "./ActualizarWS.vue?vue&type=script&lang=js&"
export * from "./ActualizarWS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports